<template>

<div class="pt-3 px-3">

    <div class="alert alert-secondary text-center" role="alert">
          <i class="fas fa-circle-info mr-2"></i>Click the banner to copy code then paste on your website
        </div>

    <div class="row">
        <div class="col-md-3 col-6 mb-3 pb-2" v-for="(banner, index) in banners" :key="index">
                <a href="#/" @click="setBannerCode(banner.id)"><img class="w-100 rounded" :src="`/images/banners/${banner_name}${banner.id}.png`"></a>
                <input type="hidden" :id="`banner-code-${banner.id}`" :value="rawHTML">
        </div>
    </div>
  
</div>

</template> 

<script>
export default {
  props: ['url'],

  data() {
    return {
        banner_name: 'supalytic-banner-',
        rawHTML: '',
        host: 'https://supalytic.com',
        banners: [
            {id: 8},
            {id: 7},
            {id: 6},
            {id: 5},
            {id: 4},
            {id: 3},
            {id: 2},
            {id: 1},
        ]
    };
  },

  created() {

    if (this.url.includes('localhost')) {
            this.host = 'http://localhost:8004';
        }
    
  },

  methods: {

    setBannerCode(banner_id) {

        this.rawHTML = `<a href="${this.url}" target="_blank"><img src="${this.host}/images/banners/supalytic-banner-${banner_id}.png" alt="Supalytic Banner"></a>`
        setTimeout(() => {
            this.copyBannerCode(banner_id)
        }, 1);

    },

    copyBannerCode (banner_id) {
          let testingCodeToCopy = document.querySelector(`#banner-code-${banner_id}`)
          testingCodeToCopy.setAttribute('type', 'text')
          testingCodeToCopy.select()

          try {
            var successful = document.execCommand('copy');
            this.showToaster('Banner code has been copied');
          } catch (err) {
            this.showToasterError('Copy failed');
          }

          /* unselect the range */
          testingCodeToCopy.setAttribute('type', 'hidden')
          window.getSelection().removeAllRanges()
        },
    
    showToaster(text) {
      this.$toaster.success(text, { timeout: 2000 });
    },
    showToasterError(text) {
      this.$toaster.error(text, { timeout: 2000 });
    }
    
  }


}
</script>

<style scoped>
.alert-secondary {
  background-color: #f7f7f7 !important;
  border-color: #e3e3e3 !important;
}
</style>